@let _files = files();
@let _progressMap = progressMap();
@let _progressStats = progressStats();
@let _height = height();
@let _size = size();
@let _centerContent = centerContent();

<div
  #dropZone
  class="flex-1 rounded-md border-2 border-dashed border-slate-200 content-center"
  [ngClass]="!!_height ? `h-[${_height}]` : 'h-auto'"
>
  @if (_files && _files.length > 0) {
    <div class="p-2 flex flex-col">
      @for (entry of files(); track $index) {
        @let _stats = _progressStats[$index];

        <div
          [ngClass]="{ 'justify-center': _centerContent }"
          class="flex flex-row items-center gap-2 flex-1"
        >
          <div
            [ngClass]="{ 'flex-1': !_centerContent }"
            class="flex flex-col gap-0"
          >
            <div class="flex-1">
              <span
                [ngClass]="{
                  'text-sm': _size === 'default',
                  'text-2xl': _size === 'xl'
                }"
                class="text-slate-900"
              >
                {{ entry.name }}
              </span>
            </div>

            @if (!disableUpload()) {
              <div>
                @switch (status()) {
                  @case (DropzoneUploadStatus.STAND_BY) {
                    <span class="text-xs italica text-slate-400">
                      {{ "In attesa" | transloco }}
                    </span>
                  }
                  @case (DropzoneUploadStatus.IN_PROGRESS) {
                    <span class="text-xs italic text-slate-400">
                      {{
                        "Caricato [loaded] di [total]"
                          | transloco
                            : {
                                loaded: _stats.loaded | fileSize,
                                total: _stats.total | fileSize
                              }
                      }}
                      - {{ _stats.speed | fileSize }}/s
                    </span>
                  }
                  @case (DropzoneUploadStatus.DONE) {
                    <span class="text-xs italic text-green-400">
                      {{ "Completato" | transloco }}
                    </span>
                  }
                  @case (DropzoneUploadStatus.ERROR) {
                    <span class="text-xs italic text-red-400">
                      {{ "Errore" | transloco }}
                    </span>
                  }
                }
              </div>
            }

            @if (!hideProgressBar()) {
              <dx-progress-bar
                [value]="_progressMap[$index] || 0"
                [min]="0"
                [max]="100"
                [showStatus]="false"
              ></dx-progress-bar>
            }
          </div>

          <dx-button
            [disabled]="status() === DropzoneUploadStatus.IN_PROGRESS"
            icon="fa-light fa-trash"
            (onClick)="onRemove($index)"
          ></dx-button>
        </div>
      }
    </div>
  }

  @if (!_files || _files.length === 0) {
    <div
      class="p-8 flex items-center justify-center cursor-pointer"
      (dragover)="
        dropZone.classList.remove('border-slate-200');
        dropZone.classList.add('border-slate-400');
        onDragOver($event)
      "
      (dragleave)="
        dropZone.classList.remove('border-slate-400');
        dropZone.classList.add('border-slate-200')
      "
      (drop)="onDrop($event)"
      (click)="onClick()"
    >
      <div>
        <span class="text-xs text-slate-900 underline cursor-pointer">
          @if (!!icon()) {
            <i [class]="`${icon()} text-slate-300`"></i>
          }
          {{ label() || "" | htmlToText }}
        </span>
      </div>
    </div>
  }
</div>
